import { queryOptions, useQuery } from '@tanstack/react-query';

import { queryClient } from '@/slw/shared/query-client';
import { PageResponse } from '@/slw/shared/types/api.type';

import { MyListingItem, MyListingRequest } from './my-listings.type';
import { getMyListings, getUserPackage } from './api-client.api';

export const MY_LISTINGS_ROOT_QUERY_KEY = ['MY_LISTINGS'];

export const useMyListingsQuery = (params: MyListingRequest) => {
  return useQuery(
    queryOptions({
      queryKey: [...MY_LISTINGS_ROOT_QUERY_KEY, JSON.stringify(params)],

      queryFn: async () => {
        const caller = await getMyListings(params);

        return caller;
      },

      initialData: () => queryClient.getQueryData<PageResponse<MyListingItem[]>>([...MY_LISTINGS_ROOT_QUERY_KEY]),

      initialDataUpdatedAt: Date.now(),

      enabled: !!params.userId,
    }),
  );
};

export const useUserPackageQuery = () => {
  return useQuery(
    queryOptions({
      queryKey: ['USER_PACKAGE'],

      queryFn: async () => {
        const caller = await getUserPackage();

        return caller;
      },
    }),
  );
};
